<template>
  <swiper :breakpoints="swiperOptions.breakpoints" :slides-per-view="1" :space-between="10" :navigation="true"
    :loop="true" :modules="modules" class="items-slider">
    <swiper-slide v-for="item in swiper" :key="item" class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
      <div class="card rated-product " :class="item.bg">
        <div class="card-body">
          <div class="img-wrapper"><img class="img-fluid" :src="getImgUrl(item.img)" alt="wellington-shoes"><span
              class="badge badge-primary rated-product-badge">{{ item.badge }}</span></div>
          <div class="product-detail"> <router-link :to="'/ecommerce/product/page/' + item.id">
              <h4>{{ item.name }}</h4>
            </router-link>
            <h3>{{ item.price }}</h3>
            <ul class="rating-star">
              <li> <i class="fa fa-star"></i></li>
              <li> <i class="fa fa-star"></i></li>
              <li> <i class="fa fa-star"></i></li>
              <li> <i class="fa fa-star"></i></li>
              <li> <i class="fa fa-star"></i></li>
            </ul>
          </div>
        </div>
      </div>
    </swiper-slide>

  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { mapState } from 'vuex'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation } from "swiper";

export default {
  name: 'productPage',
  components: { Swiper, SwiperSlide },

  data() {
    return {
      swiperOptions: {
        breakpoints: {

          421: {
            slidesPerView: 2

          }
        },
      },
    }
  },
  computed: {
    ...mapState({
      swiper: (state) => state.common.swiper,
    }),
  },
  methods: {
    getImgUrl(path) {
      return require("@/assets/images/" + path);
    },
  },
  setup() {
    return {

      modules: [Navigation],
    };
  },
}
</script>
